module.exports = __webpack_public_path__ + "img/maos-acorrentadas.jpg";